import { LOG_OUT } from "../login/action";
import { SET_DRIVER_VIEWORDER_STATES } from "./action";

export const defaultState={
    driverViewOrderStateList:[]
}

function driverViewOrderReducer(state=defaultState,action){
    switch (action.type) {
       case SET_DRIVER_VIEWORDER_STATES:
           return{
               ...state,
               driverViewOrderStateList:action.payload
           }
        case LOG_OUT:
            return defaultState;
        default:
          return state;
      }
}

export default driverViewOrderReducer;